/**
 * Invoice Ninja (https://invoiceninja.com).
 *
 * @copyright Copyright (c) 2022. Invoice Ninja LLC (https://invoiceninja.com)
 *
 * @copyright Copyright (c) 2022. Invoice Ninja LLC (https://invoiceninja.com)
 *
 * @license https://www.elastic.co/licensing/elastic-license
 */

export const enum RecurringInvoiceStatus {
  DRAFT = '1',
  ACTIVE = '2',
  PAUSED = '3',
  COMPLETED = '4',
  PENDING = '-1',
}
